<template>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap;" class="q-mt-xs q-mb-sm">
        <div v-for="(col,j) in items" :key="j" style="width: 300px; max-width: 300px; display: flex; flex-direction: row;" class="q-mr-md">

            <q-btn
                   flat
                   dense
                   no-caps
                   class="text-weight-regular subtitle-1 q-py-none"
                   style="color: var(--v-primaryText-base);"
                   @click="toggleColumn(col)">
                <q-icon
                    class="q-mr-xs"
                    :name="columnLookup[col.ColId]?.hide ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-marked'"
                    :color="columnLookup[col.ColId]?.hide ? undefined : 'primary'"
                />
          
                <span class="ellipsis" :style="{ maxWidth: columnLookup[col.ColId]?.hide ? '210px' : '180px' }">{{ Translate(col.Title) }}</span>
            </q-btn>

            <q-space></q-space>

            <q-btn
                v-if="!columnLookup[col.ColId]?.hide && !ReadOnly"
                flat
                dense
                no-caps
                size="sm"
                class="text-weight-regular subtitle-1 q-py-none"
                :icon="default_visibility[col.ColId] ? 'mdi-eye-off' : 'mdi-eye'"
                style="color: var(--v-darkGreyIcon-base);"
                @click="setDefaultHidden(col, !default_visibility[col.ColId])">
                <q-tooltip anchor="bottom middle" self="top middle" :delay="350" transition-show="scale" transition-hide="scale">
                    <span style="font-size: larger;">
                        {{ Translate('Toggle Default Visibility') }}
                    </span>
                </q-tooltip>
            </q-btn>

            <q-btn
                flat
                dense
                size="sm"
                class="q-ma-none"
                icon="mdi-information"
                xclass="q-ma-none"
                style="color: var(--v-checkboxGrey-base);"
                @click="showHelp(col)">
                <q-tooltip anchor="bottom middle" self="top middle" :delay="350" transition-show="scale" transition-hide="scale">
                    <span style="font-size: larger; font-weight: bold;">{{ Translate(col.Category) }} - {{ Translate(col.Title) }}</span><br />
                    <span style="font-size: larger;">{{ getColumnHelp(col) }}</span><br />
                    <span style="font-style: italic;" v-if="col.Sources">{{ Translate('Source(s):') }} {{ col.Sources.join(', ') }}</span>
                    <br v-if="col.Dependencies && col.Dependencies.Modules.length" />
                    <span style="font-style: italic;" v-if="col.Dependencies && col.Dependencies.Modules.length">{{ Translate('Module(s):') }} {{ col.Dependencies.Modules.join(', ') }}</span>
                </q-tooltip>
            </q-btn>
        </div>
    </div>
</template>

<script>
    import common from './common.js';
    import methods from '@/Shared/methods';

    export default {
        data: function () {
            return {
                default_visibility: {}
            }
        },
        props: {
            ReadOnly: null,
            items: {
                type: Array,
                default: () => []
            },
            columnLookup: null,
            column_default_visibility: null,
            showHelp: null,
            addColumn: null,
            removeColumn: null,
            getColumnHelp: null,
        },
        created() {
            if (this.column_default_visibility)
                this.default_visibility = { ...this.column_default_visibility };
        },
        methods: {
            ...methods,
            getDefaultHidden(col) {
                return this.default_visibility[col.ColId] ? 1 : 0;
            },
            setDefaultHidden(col, hidden) {
                if (hidden)
                    this.default_visibility[col.ColId] = 1;
                else
                    delete this.default_visibility[col.ColId];

                this.$emit('setdefaulthidden', col, hidden);
            },
            toggleColumn(col) {
                if (this.columnLookup[col.ColId]) {
                    this.columnLookup[col.ColId].hide = !this.columnLookup[col.ColId].hide;
                    if (this.columnLookup[col.ColId].hide)
                        this.setDefaultHidden(col.ColId, false);

                    this.$emit('setvisible', col, !this.columnLookup[col.ColId].hide);
                }
            },
        }
    }
</script>

<style scoped>
    .hidden-element {
        visibility: hidden;
    }

    .columns-two {
        column-count: 2;
    }

    .columns-three {
        column-count: 3;
    }

    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }

    p {
        font-size: 2em;
        text-align: center;
    }

    .metric_normal {
    }

    .metric_inuse {
        color: cornflowerblue;
    }

    .metric_usedup {
        color: silver;
    }
</style>